import axios from "@/utils/axios";

export default {
  // 修改当前用户的信息
  modifyInfo(form) {
    return axios.post(`/auth/modifyInfo`, form);
  },

  // 获取当前登录用户信息(获取菜单)
  getCurrentUser() {
    return axios.get("/auth/currentUser");
  },

  // 获取验证码
  kaptcha() {
    return axios.get("/auth/kaptcha", {
      responseType: "blob",
    });
  },
  // 安置区列表
  areaList(params) {
    return axios.get("/resettlement/area/list", { params: { ...params } });
  },

  // 用户名密码登录
  login(form) {
    return axios.post("/auth/login", form);
    // return axios.post("/auth/dev_login", form); //无需验证码的测试端接口
  },

  // 退出登录
  logout() {
    return axios.post("/auth/logout");
  },

  // 修改当前用户密码
  modifyPassword(form) {
    return axios.post(`/auth/modifyPassword`, form);
  },

  // 获取当前登录用户所有菜单(获取功能操作权限)
  getMenuAndOperate() {
    return axios.get("/auth/getMenuAndOperate");
  },

  /**
   * 获取下级行政区
   * @param {*} divisionnum 行政区编号
   */
  getDivision(divisionnum, source) {
    return axios.get("/division/children", {
      params: {
        divisionnum,
        source,
      },
    });
  },

  /**
   * 自然村列表
   * @param {*} villageCode 村编号
   * @returns
   */
  getNatureVillage(villageCode) {
    return axios.get("/division/natureVillage", {
      params: {
        villageCode,
      },
    });
  },

  // 获取成就展系统token
  getAchievementToken() {
    return axios.get("/auth/achievement/token");
  },

  // 获取考核县
  getCountis() {
    return axios.get("/evaluate/counties");
  },

  // 获取行政区str
  getdivisionbycode(params) {
    return axios.post("/division/getdivisionbycode", params);
  },
};
